import { useAuthStore } from "../store/auth.store";
import { useEffect, useState } from "react";
import { useVendorsStore } from "../store/vendors.store";
import { useVendors } from "../hook/partner/vendors.partner.hook";
import { PartnerApi } from "../api/partner.api";
import { NavLink } from "react-router";
import { useBreadcrumbsStore } from "../store/breadcrumbs.store";
import { useTranslation } from "../hooks/useTranslation";

function Vendors() {
  const { t } = useTranslation();
  const vendorsMutation = useVendors();

  const token = useAuthStore((state) => state.token);
  const user = useAuthStore((state) => state.user);
  const vendors = useVendorsStore((state) => state.vendors);

  const setBreadcrumbs = useBreadcrumbsStore((state) => state.setBreadcrumbs);
  const setPagename = useBreadcrumbsStore((state) => state.setPagename);
  useEffect(() => {
    setPagename(t("vendors.title"));
    setBreadcrumbs([]);
  }, []);

  useEffect(() => {
    if (token) {
      vendorsMutation.mutate({ token });
    }
  }, [token]);

  let vendorsMy = [];
  let vendorsOthers = vendors;

  if (vendors && vendors.length > 0) {
    user?.role?.forEach((role) => {
      if (role.role_id === "vendors") {
        role.val?.forEach((val) => {
          vendorsMy = vendorsMy.concat(
            vendorsOthers.filter((v) => v.vendor_id === val.vendor_id)
          );
          vendorsOthers = vendorsOthers.filter(
            (v) => v.vendor_id !== val.vendor_id
          );
        });
      }
    });
  }

  return (
    <>
      {vendorsMy?.length > 0 && (
        <>
          <h2 className="mb-4">{t("vendors.myVendors")}</h2>
          <div className="row mb-8">
            {vendorsMy?.map((vendor, vendor_key) => (
              <div key={vendor_key} className="col-12 col-sm-6 col-md-3 pb-5">
                <NavLink
                  to={`/produkty/${vendor.vendor_id}`}
                  className={
                    "card p-5 d-flex justify-content-center align-items-center h-100"
                  }
                >
                  <img
                    className="mw-100"
                    style={{
                      aspectRatio: "1 / 1",
                      objectFit: "contain",
                    }}
                    src={
                      PartnerApi.url +
                      "/vendor/" +
                      vendor.vendor_id +
                      "/logo.jpg"
                    }
                    alt={vendor.name}
                  />
                </NavLink>
              </div>
            ))}
          </div>
          <h2 className="mb-4">{t("vendors.otherVendors")}</h2>
        </>
      )}

      {vendorsOthers?.length > 0 ? (
        <>
          <div className="row">
            {vendorsOthers?.map((vendor, vendor_key) => (
              <div key={vendor_key} className="col-12 col-sm-6 col-md-3 pb-5">
                <NavLink
                  to={`/produkty/${vendor.vendor_id}`}
                  className={
                    "card p-5 d-flex justify-content-center align-items-center h-100"
                  }
                >
                  <img
                    className="mw-100"
                    style={{
                      aspectRatio: "1 / 1",
                      objectFit: "contain",
                    }}
                    src={
                      PartnerApi.url +
                      "/vendor/" +
                      vendor.vendor_id +
                      "/logo.jpg"
                    }
                    alt={vendor.name}
                  />
                </NavLink>
              </div>
            ))}
          </div>
        </>
      ) : (
        <>-</>
      )}
    </>
  );
}

export default Vendors;
